import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { APPLICATION_ID, COFIDIS_SDK_URL, LYZI_SDK_URL } from '../../constants';

const ScriptContainer = ({ order }) => {
    useEffect(() => {
        if (order && order.id !== undefined) {
            if (!['111', '147'].includes(APPLICATION_ID)) {
                initGooglePayTagScript();
            }
            if (APPLICATION_ID === '111') {
                initCofidisTagScript();
            }
            if (APPLICATION_ID === '147') {
                initLyziTagScript();
            }
        }
    }, [order]);

    const initGooglePayTagScript = () => {
        if (document.getElementById('google-pay-sdk')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'google-pay-sdk';
        script.src = 'https://pay.google.com/gp/p/js/pay.js';
        script.async = true;
        document.body.appendChild(script);
    };

    const initCofidisTagScript = () => {
        const existingScript = document.getElementById('cofidis-sdk');
        if (existingScript) {
            existingScript.remove();
        }

        const script = document.createElement('script');
        script.id = 'cofidis-sdk';
        script.src = `${COFIDIS_SDK_URL}${order.id.replaceAll('-', '').substr(0, 15)}`;
        script.type = 'text/javascript';
        script.async = true;
        document.body.appendChild(script);
    };

    const initLyziTagScript = () => {
        if (document.getElementById('lyzi-sdk')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'lyzi-sdk';
        script.src = LYZI_SDK_URL;
        script.async = true;
        document.body.appendChild(script);
    };

    return null;
};

ScriptContainer.propTypes = {
    order: PropTypes.object
};

export default ScriptContainer;



// WEBPACK FOOTER //
// ./src/components/funnel/ScriptContainer.js